import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory('Pardot');

export interface IPardotSendNewUserPayload {
  email: string;
  first_name: string;
  last_name: string;
  phone: string;
  has_account?: boolean;
  company_name: string;
  company_type: string;
  role: string;
}

export interface ISendPardotNewsletterSignupPayload {
  email: string;
}

export const sendNewUser = actionCreator<IPardotSendNewUserPayload>('SEND_NEW_USER');
export const sendNewsletterSignup = actionCreator<ISendPardotNewsletterSignupPayload>('SEND_NEWSLETTER_SIGNUP');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/pardot/actions.ts